import React from "react";
import { Group, Stack, Button, Text } from "@mantine/core";
import IonIcon from '@reacticons/ionicons';

interface UnappliedTransactionWarningModalProps {
    onConfirm: () => void;
    onCancel: () => void;
    onRedirectToSubTrade?: () => void;
}

const UnappliedTransactionWarningModal: React.FC<UnappliedTransactionWarningModalProps> = ({
    onConfirm,
    onCancel,
    onRedirectToSubTrade,
}) => {
    const handleCancel = () => {
        onCancel();

        if (onRedirectToSubTrade) {
            onRedirectToSubTrade();
        }
    };
    return (
        <div className="delete-confirmation-overlay">
            <div className="delete-confirmation-box unapplied-warning-modal-box">
                <div className="unapplied-warning-header">
                    <Stack spacing="4px" className="unapplied-warning-content">
                        <Group spacing="12px" align="center">
                            <div className="unapplied-warning-icon-container">
                                <IonIcon
                                    name="warning-outline"
                                    className="unapplied-warning-icon"
                                />
                            </div>
                            <Text className="unapplied-warning-title">
                                Confirm
                            </Text>
                        </Group>

                        <div className="unapplied-warning-message-container">
                            <Text className="unapplied-warning-message">
                                A Paydown or PIK transaction exists on this SubTrade that has not been applied. Would you like to proceed with signing?
                            </Text>
                        </div>
                    </Stack>
                </div>


                <div className="unapplied-warning-footer">
                    <Group position="right" spacing="8px">
                        <Button
                            variant="filled"
                            className="unapplied-warning-proceed-button unapplied-warning-buttons"
                            onClick={onConfirm}
                        >
                            Proceed
                        </Button>
                        <Button
                            variant="outline"
                            className="unapplied-warning-cancel-button unapplied-warning-buttons"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Group>
                </div>
            </div>
        </div>
    );
};

export default UnappliedTransactionWarningModal;